import { createSSRApp } from 'vue'
import { createPinia } from 'pinia'

import App from './App.vue'
import { createAppRouter } from './router'

export function createApp(head, { memory = false } = {}) {
  const app = createSSRApp(App)
  const router = createAppRouter({ memory })
  const pinia = createPinia()

  app.use(pinia)
  app.use(router)
  if (head) {
    app.use(head)
  }

  return { app, router, pinia, head }
}
